import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose, faSearch } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import classes from './styles.module.scss'

interface INewSearchInputProps {
  placeholder?: string
  onChange?: (value: string) => void
  withClear?: boolean
}

const SearchInputComponent = (props: INewSearchInputProps, ref: React.Ref<any>) => {
  const { placeholder, onChange, withClear = true } = props
  const [isActive, setIsActive] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  const handleActive = () => {
    setIsActive(true)
    inputRef?.current?.focus()
  }

  const handleInactive = () => {
    setIsActive(false)
    setInputValue('')
    inputRef?.current?.blur()
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
  }

  useImperativeHandle(ref, () => ({
    setInactive: () => handleInactive(),
    setActive: () => handleActive(),
  }), [])

  useEffect(() => {
    onChange?.(inputValue)
  }, [inputValue, onChange])

  return (
    <form autoComplete='off' onSubmit={handleSubmit} className={classNames({
      [classes.container]: true,
      [classes.container__active]: isActive,
    })}>
      <span
        onClick={handleActive}
        className={classes.searchIcon}
      >
        <FontAwesomeIcon icon={faSearch} size="sm" />
      </span>
      <input
        type="search"
        autoComplete="off"
        ref={inputRef}
        className={classNames({
          [classes.input]: true,
          [classes.input__active]: isActive,
        })}
        placeholder={placeholder || 'Search'}
        value={inputValue}
        onChange={handleChange}
      />
      {withClear &&
        <span
          onClick={handleInactive}
          className={classNames({
            [classes.closeIcon]: true,
            [classes.closeIcon__active]: isActive,
          })}
        >
          <FontAwesomeIcon icon={faClose} size="sm" />
        </span>
      }
    </form>
  )
}

export const SearchInput = forwardRef(SearchInputComponent)